import { createSelector } from '@reduxjs/toolkit';
import { resourceSelectors } from '../../utils/resourceSelectors';

export const [
  apiClientsAllIds,
  apiClientsById,
  allApiClientsSelector,
  apiClientsMetaSelector,
] = resourceSelectors('apiClients');

// The scopes a client may ask for, as the API lists them — never hard-coded,
// so a scope the API adds shows up without an app release.
export const availableScopesSelector = createSelector(
  apiClientsMetaSelector,
  (meta) => meta?.availableScopes || []
);
